import { render } from "./NeotivTrialsResources.vue?vue&type=template&id=15764c12&scoped=true"
import script from "./NeotivTrialsResources.vue?vue&type=script&lang=js"
export * from "./NeotivTrialsResources.vue?vue&type=script&lang=js"

import "./NeotivTrialsResources.vue?vue&type=style&index=0&id=15764c12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15764c12"]])

export default __exports__